<template>
  <div>
    <div id="popupBackground">
      <div @click="onDialogClose" id="triggerClick" aria-hidden="true"></div>
      <vx-card
        ref="dialog"
        role="dialog"
        aria-modal="true"
        :aria-label="iframeTitle"
        id="videoPopup"
      >
        <div tabindex="0" data-focus-sentinel @focus="focusLastInDialog"></div>
        <div class="flex flex-row-reverse">
          <vs-button
            :aria-label="`Close ${iframeTitle}`"
            size="large"
            type="flat"
            icon="close"
            @click="onDialogClose"
          />
        </div>
        <div class="video-responsive">
          <iframe :src="iframeSrc" :title="iframeTitle" frameborder="0" allow="autoplay"></iframe>
        </div>
        <div tabindex="0" data-focus-sentinel @focus="focusFirstInDialog"></div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import store from '@/store/store';
import { mapGetters } from 'vuex';
import dialogMixin from '@/mixins/dialog';
export default {
  mixins: [dialogMixin],
  computed: {
    ...mapGetters({
      focusElemOnPopupClose: 'popup/getFocusElemOnPopupClose',
    }),
    iframeSrc() {
      return this.$store.getters['popup/iframePopupSrc'];
    },
    iframeTitle() {
      // Every iframe needs an accessible name (WCAG SC 4.1.2). Callers that know what they
      // are embedding should dispatch showIframePopup({ src, title }); otherwise derive
      // something better than "Popup content" from what is being embedded.
      const title = this.$store.getters['popup/iframePopupTitle'];
      if (title) return title;

      const src = String(this.iframeSrc || '');
      if (/\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(src)) return 'Image preview';
      if (/\.(mp4|webm|ogg)(\?|$)/i.test(src)) return 'Video';
      if (/\.pdf(\?|$)/i.test(src)) return 'PDF document';
      try {
        const host = new URL(src, window.location.href).hostname;
        if (/youtube\.com|youtu\.be/.test(host)) return 'YouTube video';
        if (/vimeo\.com/.test(host)) return 'Vimeo video';
        return `Embedded page from ${host}`;
      } catch (e) {
        return 'Popup content';
      }
    },
    iframePopupVisible() {
      return this.$store.getters['popup/iframePopupVisible'];
    },
  },
  methods: {
    onDialogClose() {
      // Prefer a caller-nominated trigger over whatever held focus at open time; the
      // mixin performs the actual restore on teardown.
      const elem = document.getElementById(this.focusElemOnPopupClose);
      if (elem) {
        this.dialogReturnFocusTo = elem;
        store.commit('popup/setFocusElemOnPopupClose', null);
      }
      store.commit('popup/setIframePopupVisible', false);
    },
  },
};
</script>
<style scoped>
#videoPopup {
  position: fixed;
  top: 10%;
  width: 60%;
  left: 20%;
}
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
#popupBackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
#popupBackground #triggerClick {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 768px) {
  #videoPopup {
    top: 10%;
    width: 94%;
    left: 3%;
  }
}
</style>
